import { Route } from 'react-router-dom';
import cc from 'classcat';
import {
  DESKTOP_RIGHT_WRAPPER_Z_INDEX,
  GAME_TYPE_LIVE
} from 'utils/constants/sportsbook/generic';
import { TARGET_IDS_BY_LAYOUT } from 'utils/constants/sportsbook/scroll-target-ids';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { mountPoint } from 'utils/generic/route-manipulation';
import { routePathWithMockedDataCheck } from 'utils/helpers';
import { ESportsbookLayoutTypes } from 'interfaces/sportsbook-configs';
import { AdvancedLeftSideBar } from './__partials/AdvancedLeftSideBar';
import { AdvancedMainContent } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent';
import { ADVANCED_SPORT_BY_COMPETITIONS_LAYOUT_SHOW_EVENTS_BUTTON_ID } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedCompetitionsBySportLayout';
import { useAdvancedInitialRedirection } from 'newelements/Sportsbook/layouts/advanced/hooks/useAdvancedInitialRedirection';
import { useRedirectToAdvancedRoute } from 'newelements/Sportsbook/layouts/advanced/hooks/useRedirectToAdvancedRoute';
import { DesktopRight } from 'newcomponents/Shared/DesktopRight';
import { HooryAiCardLazyWrapper } from 'newcomponents/Shared/generic/HooryAI/HooryAICard/HooryAiCardLazyWrapper';
import { HooryAICompact } from 'newcomponents/Shared/generic/HooryAI/HooryAICompact';
import { Col } from 'newcomponents/UI/Col';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import { useSearchParams } from 'hooks/useSearchParams';
import './index.less';

export const ADVANCED_LEFT_MENU_SHOW_EVENTS_BUTTON_ID =
  'advancedLeftMenuShowEventsButton';

export const DesktopSportsbookAdvanced = () => {
  useRedirectToAdvancedRoute();
  useAdvancedInitialRedirection();

  const configs = useSportsbookConfigs();
  const { gameType } = useSearchParams();

  return (
    <>
      <Col
        className={cc([
          {
            SBCol: configs.fit === 'cover',
            'prematch__type-page': configs.type === 'prematch'
          }
        ])}
        data-popover-parent
        style={{ overflow: 'hidden', flex: '1', padding: 0 }}
      >
        <div className="desktopSportsbookAdvancedCol">
          <HooryAICompact />
          <AdvancedLeftSideBar />
        </div>
        <div id={ADVANCED_LEFT_MENU_SHOW_EVENTS_BUTTON_ID} />
      </Col>
      <Col
        className={cc([{ SBCol: configs.fit === 'cover' }])}
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          padding: 0
        }}
        xs={15}
      >
        <div
          className="desktopSportsbookAdvancedCol"
          id={TARGET_IDS_BY_LAYOUT[ESportsbookLayoutTypes.ADVANCED]}
        >
          <AdvancedMainContent />
        </div>
        <div id={ADVANCED_SPORT_BY_COMPETITIONS_LAYOUT_SHOW_EVENTS_BUTTON_ID} />
      </Col>
      <Route
        path={routePathWithMockedDataCheck(
          `${mountPoint(
            window.getPathname()
          )}${'/:sport?/:region?/:competition?/:game?'}`
        )}
      >
        <Col
          className={cc([{ SBCol: configs.fit === 'cover' }])}
          xs={5}
          style={{
            zIndex: DESKTOP_RIGHT_WRAPPER_Z_INDEX,
            display: SpringConfigs.HOORY_ENABLED_SPORTSBOOK_BETSLIP
              ? 'flex'
              : 'block',
            flex: '1'
          }}
        >
          <DesktopRight isLive={Number(gameType) === GAME_TYPE_LIVE} />
          <HooryAiCardLazyWrapper />
        </Col>
      </Route>
    </>
  );
};
